
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './Pages/Home/Home/Home';
import Navbar from './Pages/Shared/Navbar';
import Contact from './Pages/Contact/Contact';
import Footer from './Pages/Shared/Footer';
import ProjectOne from './Pages/Details/ProjectOne';
import ProjectTwo from './Pages/Details/ProjectTwo';
import ProjectThree from './Pages/Details/ProjectThree';
import About from './Pages/About/About';
import Blogs from './Pages/Blogs/Blogs';
import ProjectFour from './Pages/Details/ProjectFour';


function App() {
  return (
    <div className="App bg-slate-100 ">
      <Navbar></Navbar>

      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/about" element={<About></About>}></Route>
        <Route path="/blogs" element={<Blogs></Blogs>}></Route>
        <Route path="/contact" element={<Contact></Contact>}></Route>
        <Route path="/project1" element={<ProjectOne></ProjectOne>}></Route>
        <Route path="/project2" element={<ProjectTwo></ProjectTwo>}></Route>
        <Route path="/project3" element={<ProjectThree></ProjectThree>}></Route>
        <Route path="/project4" element={<ProjectFour></ProjectFour>}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;
